import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import CartOverview from './CartOverview';

const CartDrawer = ({ open, cart = null, onClose = null }) => {
    useEffect(() => {
        if (!open) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && onClose) {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [open, onClose]);

    if (!open) {
        return null;
    }

    return createPortal(
        <>
            <div
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{
                    background: 'rgba(15, 18, 25, 0.45)',
                    backdropFilter: 'blur(2px)',
                    zIndex: 1050,
                }}
                onClick={onClose}
                aria-hidden="true"
            />
            <aside
                className="position-fixed top-0 end-0 bg-white d-flex flex-column shadow-lg"
                style={{
                    width: 'min(560px, 100vw)',
                    height: '100vh',
                    maxWidth: '100vw',
                    zIndex: 1051,
                }}
                role="dialog"
                aria-modal="true"
                aria-label="Shopping cart"
            >
                <CartOverview initialCart={cart} variant="drawer" onClose={onClose} />
            </aside>
        </>,
        document.body
    );
};

export default CartDrawer;
